import { FC, memo, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import { useFela } from 'react-fela';
import { Box } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { getScreenType } from '@bridebook/web/lib/app/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import componentStyles from './top-bar-header-item.style';

export interface ITopBarHeaderItemProps {
  href?: string;
  dataName: string;
  label: string;
  icon: string;
  onClick?: MouseEventHandler<ReactNode>;
  endIconText?: ReactNode;
}

const TopBarHeaderItem: FC<ITopBarHeaderItemProps> = ({
  href,
  dataName,
  label,
  icon,
  onClick,
  endIconText,
}) => {
  const { css } = useFela();
  const { isDesktop } = useSelector(getScreenType);

  return (
    <LinkWrap href={href}>
      <Box style={componentStyles.wrapper} data-name={dataName} onClick={onClick}>
        {isDesktop && <div className={css(componentStyles.label)}>{label}</div>}
        {!isDesktop && (
          <Box style={componentStyles.buttonWrapper}>
            <img
              src={`${IMAGES_BASE_URL}/assets/icons/top-bar/${icon}.svg`}
              width={22}
              height={25}
            />
          </Box>
        )}
        {endIconText}
      </Box>
    </LinkWrap>
  );
};

const LinkWrap: React.FC<Pick<ITopBarHeaderItemProps, 'href'> & PropsWithChildren> = ({
  children,
  href,
}) => {
  if (href) {
    return (
      <Link href={href} legacyBehavior>
        {children}
      </Link>
    );
  } else {
    return <>{children}</>;
  }
};

export default memo(TopBarHeaderItem);
